// extracted by mini-css-extract-plugin
export default {"addAppointmentButton":"add-appointment_addAppointmentButton__XswUq"};